const rawClubs = [
  "\"APRÓ PATÁK\" LOVAS SPORT EGYESÜLET",
  "\"CSABA\"LOVAS-ÍJÁSZ KÖR",
  "\"UNICORNIS\" EGRI ÍJÁSZ SPORTEGYESÜLET",
  "3D SPORTEGYESÜLET",
  "ADÁCSI DIÁKSPORT EGYESÜLET",
  "ALBA ÍJÁSZ HAGYOMÁNYŐRZŐ ÉS SPORTEGYESÜLET",
  "ALIBI ÍJÁSZ KLUB KÖZHASZNÚ EGYESÜLET",
  "ALISCA NYILAI ÍJÁSZ EGYESÜLET",
  "ALPOKALJA ÍJÁSZ SPORTEGYESÜLET",
  "ALSÓŐRSI SPORTEGYESÜLET",
  "ANARCSI íJÁSZOK HAGYOMÁNYŐRZŐ EGYESÜLETE",
  "Arrabona Íjász Egyesület",
  "ATKÁRI SPORTEGYESÜLET",
  "ATTILA NYILAI EGYESÜLET",
  "BAJI KÖZSÉGI SPORTEGYESÜLET",
  "BAKONY ÍJÁSZ EGYESÜLET",
  "BAKONYJÁKÓI ÍJÁSZ ÉS HAGYOMÁNYÖRZŐ EGYESÜLET",
  "BAKONSZEGI HAGYOMÁNYŐRZŐ EGYESÜLET",
  "BAKONSZEGI VEZÉRTOLLAK",
  "BÁSTYA ÍJÁSZ KLUB",
  "Tarnamenti Íjász Klub",
  "BALATONFŐKAJÁRI ÍJÁSZ SPORT ÉS HAGYOMÁNYŐRZŐ EGYESÜLET",
  "BALATONFŰZFŐI LÖVÉSZ EGYLET",
  "BARACSI ÍJÁSZ EGYESÜLET",
  "BERCSÉNYI MIKLÓS DSE ÍJÁSZ SZAKOSZTÁLY",
  "BERZENCEI IFJÚSÁGÉRT ÉS KULTÚRÁÉRT EGYESÜLET",
  "BORONKAI HAGYOMÁNYŐRZŐ ÉS ÍJÁSZ EGYESÜLET",
  "BOTTYÁN JÁNOS SZAKGIMNÁZIUM SPORTEGYESÜLET",
  "BUCSAI HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "BUDAKÖRNYÉKI ÍJÁSZ EGYESÜLET",
  "BUDAPESTI ÍJÁSZ SZÖVETSÉG",
  "BUDAPESTI SPORTÍJÁSZ EGYESÜLET",
  "CANI DI CARTA PAPÍRKUTYÁK SPORTEGYESÜLET",
  "CÉLLÖVŐK ÍJÁSZ EGYESÜLET",
  "CÉLPONT-2010 Kft.",
  "Ceglédberceli Hagyományéltető Íjászegyesület",
  "CSEMŐI PALOTÁS SPORTEGYESÜLET",
  "CSODASZARVAS SPORTEGYESÜLET",
  "CSOKMA ÍJÁSZ ÉS HAGYOMÁNYŐRZŐ SPORTEGYESÜLET",
  "CSERSZEGTOMAJI SPORT KLUB",
  "DEBRECENI LÖVÉSZ EGYLET",
  "DELTA ÍJÁSZ EGYESÜLET",
  "DOROZSMAI ÍJÁSZOK BARÁTI KÖRE SPORTEGYESÜLET",
  "DóRiA ŐRZŐI HAGYOMÁNYÖRZŐ ÍJÁSZ EGYESÜLET",
  "DSZC-LETIZIA SPORTCLUB EGYESÜLET",
  "DUNAVECSEI SPORTEGYESÜLET",
  "DÉLI FARKASOK SPORT ÉS HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "DÉVAVÁNYAI HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "EGRI VITÉZLŐ OSKOLA HAGYOMÁNYŐRZŐ ÉS SPORT KÖZHASZNÚ EGYESÜLET",
  "ELEVEN VILÁG ÍJÁSZ EGYESÜLET",
  "ENCSENCSI VADÁSZ ÍJÁSZ EGYESÜLET",
  "EURÓPAI ÍJÁSZSPORTOLÓK ALAPÍTVÁNYA",
  "ÉJSÓLYOM ÍJÁSZ SPORT ÉS KULTURÁLIS EGYESÜLET",
  "FARKAS FALKA ÍJÁSZ SPORTEGYESÜLET",
  "FARKASOK EGYESÜLET",
  "FARKASOK ÍJÁSZ EGYESÜLET",
  "FEGYVERNEK VÁROSI SPORTEGYESÜLET",
  "FEKETEKESE ÍJÁSZ EGYESÜLET",
  "FÜZESGYARMATI ARANY SÓLYOM HAGYOMÁNYÖRZŐ ÍJÁSZ EGYESÜLET",
  "FŐNIX ÍJÁSZ SPORTEGYESÜLET",
  "Főnix Hungary Íjász Egyesület",
  "GRIFF ÍJÁSZ EGYESÜLET",
  "GYEPŰ FARKASAI HAGYOMÁNYŐRZŐ ÉS ÍJÁSZ EGYESÜLET",
  "GÖDÖLLŐI SPORT KLUB",
  "GÖRCSÖNY ÍJÁSZAI ÍJÁSZ EGYESÜLET",
  "HAJDÚ ÍJÁSZ KLUB SE",
  "HAJDÚ íJÁSZ KLUB KÖZHASZNÚ EGYESÜLET",
  "HAJDÚNÁNÁSI HÓDOS IMRE SPORTEGYESÜLET",
  "HAJDÚSZOBOSZLÓI SPORTEGYESÜLET",
  "HAJDÚVITÉZ KSE",
  "HALASI NAPSÓLYOM ÍJÁSZ EGYESÜLET",
  "HAZA-HÚZÓ ÍJÁSZ SPORT EGYESÜLET",
  "Hanyi Íjászok Hagyományőrző Egyesület",
  "HED-LAND SPORTCSARNOK SPORTEGYESÜLET",
  "HEGYI FARKAS KÖZHASZNÚ ÍJÁSZ SPORTEGYESÜLET",
  "HETÉNYEGYHÁZI ÍJÁSZ ÉS SZABADIDŐSPORT EGYESÜLET",
  "HÉTVEZÉR ÍJÁSZ SPORTEGYESÜLET",
  "HF ELEVEN KFT. HF SASHALMI ÍJÁSZOK",
  "HONVÉD KOSSUTH LÖVÉSZ KLUB (HKLK)",
  "HONVÉD SZONDI GYÖRGY SE",
  "HUNYADIAK ÖRÖKÉBEN TÖRTÉNELMI HAGYOMÁNYŐRZŐ EGYESÜLET",
  "Huszka József Hagyományőrző Egyesület",
  "HÉVíZ SK ÍJÁSZSZAKOSZTÁLY",
  "HÉTDOMBI IFJÚSÁGI KSE ÍJÁSZ SZAKOSZTÁLY",
  "HÓDMEZEI ŐRZŐK ÍJÁSZEGYESÜLET",
  "IVÁNDÁRDA SPORTEGYESÜLET",
  "JÁSZ-KUN HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "KANIZSA ÍJÁSZ EGYESÜLET",
  "KAPOS ÍJÁSZ EGYESÜLET",
  "KASSAI LOVASÍJÁSZ ISKOLA FARAGÓ TÖRZS",
  "KASSAI LOVASÍJÁSZ ISKOLA KASSAI KÁNSÁG",
  "KASTÉLYDOMBI SPORTEGYESÜLET",
  "KAZINCBARCIKAI ÍJÁSZ EGYESÜLET",
  "KECSKEMÉTI ÍJÁSZ EGYESÜLET (KIE)",
  "KELECSÉNYI TRADICIONÁLIS ÍJÁSZ ISKOLA SPORTEGYESÜLET",
  "KERECSEN ÍJÁSZ ÉS HAGYOMÁNYŐRZŐ EGYESÜLET",
  "KERECSÉNYI LÁSZLÓ ÍJÁSZ EGYESÜLET",
  "KEREKEGYHÁZI SPORT EGYESÜLET",
  "KHTK - FÉNYPÁRDUCOK ÍJÁSZ SZAKOSZTÁLY",
  "KILITI ÍJÁSZ ÉS SZABADIDŐ EGYESÜLET",
  "KINIZSI ÍJÁSZ KÖZHASZNÚ EGYESÜLET",
  "KISTOKAJI SPORTEGYESÜLET",
  "KOPPÁNY-NEMZETSÉG ÍJÁSZ EGYESÜLET",
  "KÖZÖSSÉGI SPORT CLUB MEZŐNYÁRÁD SPORTEGYESÜLET",
  "KÉK BALATON ÍJÁSZ ALAPÍTVÁNY",
  "LAJOSKOMÁROMI ÍJÁSZ SE.",
  "LŐVÉR ÍJÁSZ SPORT CLUB KÖZHASZNÚ EGYESÜLET",
  "MAGYAR ÍJÁSZ TANODA SPORTEGYESÜLET",
  "MAGYAR LOVASÍJÁSZ AKADÉMIA SPORTEGYESÜLET",
  "MAGYAR TÁBOR HAGYOMÁNYŐRZŐ ÉS SPORT EGYESÜLET",
  "MAGYAR VADÁSZOK VADÁSZÍJÁSZ EGYESÜLETE",
  "MAGYARÓVÁRI ÍJÁSZ SE (MISE)",
  "MAKLÁRI ÍJÁSZ SPORTEGYESÜLET",
  "MALÉV-BUDAPEST AIR-HUNGAROCONTROLL SE ÍJÁSZ SZAKOSZTÁLYA",
  "MAROSMENTI ÍJÁSZOK SPORTEGYESÜLETE",
  "MATE- GÖDÖLLŐI EGYETEMI ATLÉTIKAI CLUB",
  "MAVIR SPORT EGYESÜLET",
  "MECSEK ÍJÁSZ EGYESÜLET",
  "MEGYER KÖVETŐI ÍJÁSZ EGYESÜLET",
  "MESE MINDENKI EGYÉRT SPORTEGYESÜLET",
  "MESTERÍJÁSZ KFT.",
  "MEZŐBERÉNYI ÍJÁSZ ÉS HAGYOMÁNYŐRZŐ SPORTEGYESÜLET",
  "MICSTECH KFT.",
  "MISKOLCI ÍJÁSZ EGYLET",
  "MOGYORÓDI SZENT LÁSZLÓ HAGYOMÁNYŐRZŐ ÉS ÍJÁSZ EGYSÜLET",
  "MOHÁCSI TORNA EGYTE NIMRÓD ÍJÁSZ SZAKOSZT.",
  "MONORIERDŐI ÍJÁSZ EGYESÜLET",
  "MÚLTUNK ÉS JÖVŐNK EGYESÜLET",
  "MÁTÉHEGYI ÖKOPARK ÉS SPORTCENTRUM KÖZHASZNÚ EGYESÜLET",
  "MÁTRAI FARKASOK HAGYOMÁNYŐRZŐ ÉS ÍJÁSZ EGYESÜLET",
  "MÓRI SE ÍJÁSZ SZAKOSZTÁLY",
  "NAGYABONYI ÍJÁSZOK HAGYOMÁNYŐRZŐ ÉS SPORT EGYESÜLETE",
  "NAGYHEGYESI ÍJÁSZ EGYESÜLET",
  "NIBUR NÉPE- HALADÁS VSE ÍJÁSZ SZAKOSZTÁLY",
  "NYERGESÚJFALU VÁROSI SPORTEGYESÜLET",
  "NYWYG ÍJÁSZ ÉS HAGYOMÁNYŐRZŐ EGYESÜLET",
  "NYÍLEGYENES ÍJÁSZ CLUB",
  "OROSHÁZI ÍJÁSZ EGYESÜLET",
  "OSTOROSI SPORTEGYESÜLET",
  "OXER LOVAS SPORTEGYESÜLET",
  "PAKSI CELŐKE ÍJÁSZ SPORTEGYESÜLET",
  "PARKVÁROSI VADÁSZOK HÍE",
  "PARTISCUM ÍJÁSZ KLUB KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG",
  "PEAC ÍJÁSZ SZAKOSZTÁLYA",
  "PEYTU ÍJÁSZ HAGYOMÁNYŐRZŐ EGYESÜLET",
  "PILISI KIRÁLYI ÍJÁSZOK EGYESÜLET",
  "PILISI MEDVÉK SPORT EGYEÜLET",
  "PREMONTREI SPORTEGYESÜLET",
  "PÉNZÜGYŐR SPORTEGYESÜLET",
  "PUSZTAI ÍJÁSZ",
  "RING AUTÓ-, ÍJÁSZ ÉS LOVASSPORT EGYESÜLET",
  "RUZSAI HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "RÁCALMÁS SPORTEGYESÜLET",
  "RÁCKEVE ÍJÁSZ SPORT KLUB",
  "RÁCKEVE SEREGE ÍJÁSZ SPORTEGYESÜLET",
  "RÁKOSMENTI KÖZSÉGI SPORTKÖR EGYESÜLET",
  "RÁKOSMENTI TESTEDZŐ KÖR",
  "RÉGIÓ HAGYOMÁNYŐRZŐ, KULTURÁLIS ÉS SPORTEGYESÜLET",
  "RÓZSASZÍN PÁRDUC TÖMEGSPORT EGYESÜLET",
  "SALGÓTARJÁNI BARÁTOK TORNA CLUB",
  "SCARBANTIA ÍJÁSZ EGYESÜLET",
  "SEGŐSDI HAGYOMÁNYÖRZŐ ÉS ÍJÁSZ EGYESÜLET",
  "SOPRONI RENDÉSZETI SPORTEGYESÜLET",
  "SPIRÁL SE HUNOR ÍJÁSZ SZAKOSZTÁLY",
  "SÁNDORFALVI SÓLYMOK ÍJÁSZ EGYESÜLET",
  "SÁRVÁRI HAGYOMÁNYŐRZŐ ÉS ÍJÁSZ EGYESÜLET",
  "SÁRRÉTUDVARI SZITTYÁK ÍJÁSZ EGYESÜLET",
  "SZABAD ÍJÁSZOK BARÁTI TÁRSASÁGA",
  "SÜTTŐI SPORT CLUB",
  "SZEGEDI SPORTÍJÁSZ EGYESÜLET",
  "SZENT SEBESTYÉN ÍJÁSZ ALAPÍTVÁNY",
  "SZENTGOTTHÁRDI VÁROSI SPORTEGYESÜLET ÍJÁSZ SZAKOSZTÁLY SZENT SEBESTYÉN",
  "SZITTYA HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "SZPA-HSE SZENT PÁL AKADÉMIA -HIT SE",
  "SZÁDVÁRI ORDASOK ÍJÁSZ EGYESÜLET",
  "SÓLYOM ÍJÁSZ EGYESÜLET",
  "TAMÁSI ÍJÁSZ EGYESÜLET",
  "TARJÁN ÍJÁSZ EGYESÜLET",
  "TATABÁNYAI ÍJÁSZ EGYESÜLET",
  "TATAI TÖMEGSPORT ÉS TÁJFUTÓ HONVÉD SE (TTT-HSE)",
  "TELITALÁLAT ÍJÁSZ EGYESÜLET",
  "TELL VILMOS VADÁSZ ÉS ÍJÁSZ SZABADIDŐ SPORTEGYESÜLET",
  "TERECSE ÍJÁSZ ÉS HAGYOMÁNYŐRZŐ EGYESÜLET",
  "TEREPÍJÁSZ EGYSÜLET AJKA (T.E.A.)",
  "ARCHERYNEXUS TESZT",
  "TESZT 2 EGYESÜLET",
  "THURY-VÁR VITÉZEI HAGYOMÁNYŐRZŐ- ÉS SPORTEGYESÜLET",
  "TIPOGRÁFIA TESTEDZŐ EGYESÜLET ÍJÁSZ SZAKOSZTÁLYA",
  "TISZA VOLÁN SC",
  "TISZAFÖLDVÁRI ARANYHEGY HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "TISZAVASVÁRI SPORTEGYESÜLET",
  "TOLNAI TÁJAK ÍJÁSZ KÖZHASZNÚ EGYESÜLET",
  "TRIÁSZ ÍJÁSZ EGYESÜLET",
  "TURUL KOPPÁNY ÍJÁSZAI HAGYOMÁNYÖRZÖ EGYESÜLET",
  "TURÁNI SÓLYOM HAGYOMÁNYŐRZŐ EGYESÜLET",
  "ÚJSZÁSZI HAGYOMÁNYŐRZŐ ÍJÁSZCSAPAT",
  "ÚJSZEGEDI TORNA CLUB",
  "ÚJSZENTIVÁNI ÍJÁSZ SPORTEGYESÜLET",
  "VALLUM ÍJÁSZ EGYESÜLET",
  "VEKTOR ÍJÁSZ KLUB SPORTEGYESÜLET",
  "VELEK VEZÉR HAGYOMÁNYŐRZŐ ÍJÁSZ EGYESÜLET",
  "VECSÉSI SPORTEGYESÜLET",
  "VÁNDORSÓLYOM HAGYOMÁNYŐRZŐ ÍJÁSZ ÉS SPORTEGYESÜLET",
  "VÁRTA HAGYOMÁNYŐRZŐ ÉS ÍJÁSZ KÖZHASZNÚ EGYESÜLET",
  "ÍJÁSZ ÉS SPORTLÖVŐ EGYESÜLET",
  "ÍJÁSZ ÚTJA ISKOLA EGYESÜLET",
  "ÍJÁSZKATLAN SPORTEGYESÜLET MÁTÉSZALKA",
  "ÓCSAI TORNA KLUB SPORTEGYESÜLET",
  "ÖRKÉNYI SZABAD ÍJÁSZOK EGYESÜLET",
  "ÖSKÜI ÍJÁSZOK SPORTEGYESÜLETE",
  "ÖRS ÍJÁSZ KLUB EGYESÜLET",
  "ŐSEINK ÚTJAI SPORT EGYESÜLET",
  "ZÖLD VÖLGY ÍJÁSZAI"
];

const hungarianCollator = new Intl.Collator('hu', { sensitivity: 'base' });
const sortedClubs = rawClubs.sort((a, b) => hungarianCollator.compare(a, b));

export const ARCHERY_CLUBS = ["Egyéb", ...sortedClubs];
